<template>
  <div class="page-common-container" v-loading="loading">
    <div class="page-common-container-left">
      <pageForm ref="pageForm" :title="$i18n.$t('人物筛选')" :btnName="$i18n.$t('查询')" :fields="fields" @search="search" />
    </div>
    <div class="page-common-container-right">
      <div class="page-common-container-right-content hasName">
        <chinaMap :list="relationData" :personName="personName" :nativePlaceList="nativePlaceList" @tab-change="tabChange" />
      </div>
      <div class="page-common-container-right-list hasName">
        <div class="page-common-container-right-list-title">
          <div class="page-common-container-right-list-title-top">
            <div class="page-common-container-right-list-title-top-name">{{ $i18n.$t('查询结果') }}</div>
            <el-button type="primary" @click.stop="exportData" :disabled="!relationData.length || downloadLoading" :loading="downloadLoading">{{ $i18n.$t('导出数据') }}</el-button>
          </div>
          <div class="page-common-container-right-list-title-bottom">
            {{ $i18n.$t('本次图谱共查询到') }}{{ personTotal }}{{ $i18n.$t('个节点，') }}{{ linkTotal }}{{ $i18n.$t('条人物-地点关系连边，全部数据请点击“导出数据”按钮导出。') }}
          </div>
        </div>
        <div class="page-common-container-right-list-content">
          <div class="page-common-container-right-list-content-title">{{ $i18n.$t('以下为按照人物足迹数量排序前十位的人物以及按照地点热度排序前十位的地点：') }}</div>
          <div class="page-common-container-right-list-content-item" v-for="(per, index) in addressList" :key="index">
            <div class="page-common-container-right-list-content-item-title">
              <div class="page-common-container-right-list-content-item-title-name">{{ per.Name }}</div>
              <div class="page-common-container-right-list-content-item-title-count">{{ $i18n.$t('关系数据：') }}{{ per.relation_count }}{{ $i18n.$t('条') }}</div>
            </div>
            <div class="page-common-container-right-list-content-item-table">
              <div class="page-common-container-right-list-content-item-table-head">
                <div class="page-common-container-right-list-content-item-table-head-th">{{ $i18n.$t('人物名称') }}</div>
                <div class="page-common-container-right-list-content-item-table-head-th">{{ $i18n.$t('记载出处') }}</div>
              </div>
              <template v-for="(link, j) in per.link_node">
                <div class="page-common-container-right-list-content-item-table-row" :key="j" v-if="per.showMore || (!per.showMore && j < 4)">
                  <div class="page-common-container-right-list-content-item-table-row-td">{{ link.Name }}</div>
                  <div class="page-common-container-right-list-content-item-table-row-td" :title="link.RecordedIn">{{ link.RecordedIn }}</div>
                </div>
              </template>
            </div>
            <div class="page-common-container-right-list-content-item-more" v-if="per.link_node.length > 4" @click.stop="per.showMore = !per.showMore">
              <template v-if="per.showMore">
                {{ $i18n.$t('收起') }}
                <i class="el-icon-arrow-up"></i>
              </template>
              <template v-else>
                {{ $i18n.$t('查看更多') }}
                <i class="el-icon-arrow-down"></i>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { personAddressRelation } from '@/api/home'
import { i18n } from '@/i18n'
export default {
  name: 'footPrints',
  meta: {
    title: i18n.$t('人物足迹')
  },
  data () {
    let sessionParams = sessionStorage.getItem('footprintsParams')
    if (sessionParams) {
      sessionParams = JSON.parse(sessionParams)
    }
    const Name = localStorage.getItem('footprintsName')
    if (Name) {
      localStorage.removeItem('footprintsName')
      if (!sessionParams) {
        sessionParams = {}
      }
      sessionParams.Name = Name
    }
    return {
      fields: [
        {
          type: 'person',
          label: i18n.$t('人物名称'),
          placeholder: i18n.$t('请输入想要了解的人物'),
          key: 'Name',
          defaultValue: sessionParams ? (sessionParams.Name || '') : null
        },
        {
          type: 'select',
          label: i18n.$t('人物分类'),
          placeholder: i18n.$t('全部'),
          key: 'Category',
          clearable: true,
          options: this.$store.state.dict.personCategory || [],
          defaultValue: sessionParams ? (sessionParams.Category || '') : null
        },
        {
          type: 'select',
          label: i18n.$t('传记名称'),
          placeholder: i18n.$t('全部'),
          key: 'Biographie',
          clearable: true,
          options: this.$store.state.dict.biographieName || [],
          defaultValue: sessionParams ? (sessionParams.Biographie || '') : null
        },
        {
          type: 'select',
          label: i18n.$t('宗派'),
          placeholder: i18n.$t('全部'),
          key: 'Sect',
          clearable: true,
          options: this.$store.state.dict.allSect || [],
          defaultValue: sessionParams ? (sessionParams.Sect || '') : null
        },
        {
          type: 'selectGroup',
          label: i18n.$t('时间'),
          separator: i18n.$t('至'),
          start: {
            placeholder: i18n.$t('全部'),
            key: 'Dynasty_start',
            options: this.$store.state.dict.allDynasty || [],
            defaultValue: sessionParams ? (sessionParams.Dynasty_start || '') : null
          },
          end: {
            placeholder: i18n.$t('全部'),
            key: 'Dynasty_end',
            options: this.$store.state.dict.allDynasty || [],
            defaultValue: sessionParams ? (sessionParams.Dynasty_end || '') : null
          }
        }
        // {
        //   type: 'select',
        //   label: i18n.$t('人物设置'),
        //   placeholder: i18n.$t('请选择'),
        //   key: 'is_extension',
        //   clearable: true,
        //   options: [
        //     { label: i18n.$t('显示所有人物'), value: '1' },
        //     { label: i18n.$t('仅显示传记人物'), value: '0' }
        //   ],
        //   defaultValue: '1'
        // }
      ],
      loading: false,
      relationData: [],
      personTotal: 0,
      linkTotal: 0,
      addressList: [],
      personName: '',
      downloadLoading: false,
      queryParams: {}
    }
  },
  computed: {
    nativePlaceList () {
      return this.relationData.filter(e => e.markers && e.markers.value === i18n.$t('籍贯地'))
    }
  },
  methods: {
    tabChange (Id) {
      this.getPersonRelation({
        ...this.queryParams,
        Id
      })
    },
    exportData () {
      const form = this.$refs.pageForm.form || {}
      this.downloadLoading = true
      personAddressRelation({
        type: '人物足迹',
        ...form,
        output: 1
      }, {
        responseType: 'blob'
      }).then(res => {
        const a = document.createElement('a')
        a.href = URL.createObjectURL(res)
        a.download = i18n.$t('人物足迹.xlsx')
        a.click()
        URL.revokeObjectURL(a.href)
      }).finally(() => {
        this.downloadLoading = false
      })
    },
    search (params) {
      sessionStorage.setItem('footprintsParams', JSON.stringify(params))
      this.personName = params.Name || ''
      this.getPersonRelation(params)
    },
    getPersonRelation (params) {
      this.loading = true
      this.queryParams = params
      personAddressRelation({
        type: '人物足迹',
        ...params
      }).then(res => {
        this.relationData = res.data.data.map(e => {
          return {
            ...e,
            markers: res.data.link.find(l => l.target === e.Id)
          }
        })
        this.personTotal = res.data.person.length + res.data.data.length
        this.linkTotal = res.data.link.length
        this.addressList = (res.data.sidebar || []).map(e => {
          return {
            ...e,
            showMore: false
          }
        })
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>
